import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../api'

const initialState = {
  userPoolNames: [],
  userPoolDetails: undefined,
};

const userPoolSlice = createSlice({
  name: 'userPool',
  initialState,
  reducers: {
    setUserPoolDetails: (state, action) => {
      state.userPoolDetails = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      graphqlApi.endpoints.getUserPoolDetails.matchFulfilled,
      (state, { payload }) => {
          state.userPoolDetails = payload;   
      }
    );
    builder.addMatcher(
      graphqlApi.endpoints.getUserPoolNames.matchFulfilled,
      (state, { payload }) => {
          state.userPoolNames = payload;   
      }
    );
  },
});

export const { setUserPoolDetails, setUserPoolNames } = userPoolSlice.actions;
export const selectUserPoolDetails = (state) => state.userPool.userPoolDetails || {id: "", name: "", tokenSigningKeyUrl: "", userCount: 0, details: []};
export const selectUserPoolNames = (state) => state.userPool.userPoolNames;
export default userPoolSlice.reducer;